// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "images/beginner.jpeg",
    title: "Season 4 Volume 1 Final Trailer",
    info: "watch brand new trailer",
  },
  {
    url: "images/poster.jpeg",
    title: "Season 4 Volume 1 Final Trailer",
    info: "watch brand new trailer",
  },
  {
    url: "images/boy.jpeg",
    tag: "photos",
    info: "2022 canvas Film Festival:photos we love",
  },
];
